import React from 'react';
import PropTypes from 'prop-types';
import block from 'bem-cn';
import { useSelector } from 'react-redux';
import ProviderIcon from 'components/ProviderIcon';

import SVG from 'components/SVG';

import upSVG from 'features/generalReport/img/up.svg';
import downSVG from 'features/generalReport/img/down.svg';
import { providersNames } from 'features/generalReport/data';

import formatNumber from 'shared/helpers/formatNumber';

import './TableRow.scss';

const b = block('table-providers-row-mobile');

const TableRow = ({ item, withDiff }) => {
  const locale = useSelector(state => state.locale.locale);

  const getDiffData = percent => {
    const nPercent = Number(percent);
    if (nPercent === 0 || isNaN(nPercent)) return [null, ''];
    const isPositive = nPercent > 0;
    return [
      <SVG className={b('diff-icon')} svgProps={{ svg: isPositive ? upSVG : downSVG }} />,
      isPositive ? 'green' : 'red',
    ];
  };

  const [betCountIcon, betCountColor] = getDiffData(item.betCount.percent);
  const [incomeAmountIcon, incomeAmountColor] = getDiffData(item.incomeAmount.percent);
  
  return (
    <div className={b()}>
      <div className={b('block')}>
        <div className={b('provider')}>
          <ProviderIcon className={b('provider-icon')} name={item.provider?.toLowerCase()} />
          {providersNames[item.provider?.toLowerCase()] ?? item.provider}
        </div>
        <div className={b('data', { type: 'column' })}>
          <div className={b('label')}>{locale.betAmount}</div>
          <div className={b('value')}>{formatNumber(item.betAmount.current)}</div>
        </div>
      </div>

      <div className={b('separator')}></div>

      <div className={b('block')}>
        <div className={b('label')}>{locale.winAmount}</div>
        <div className={b('value')}>{formatNumber(item.winAmount.current)}</div>
      </div>

      <div className={b('block', { type: 'accent' })}>
        <div className={b('label')}>
          {locale.betCount}
          {withDiff && (
            <div className={b('diff')}>
              {betCountIcon}
              <div className={b('diff-percent', { color: betCountColor })}>{item.betCount.percent}%</div>
              <div className={b('diff-value')}>{formatNumber(item.betCount.previous, 0)}</div>
            </div>
          )}
        </div>
        <div className={b('value')}>{formatNumber(item.betCount.current, 0)}</div>
      </div>

      <div className={b('block', { type: 'accent' })}>
        <div className={b('label')}>
          {locale.incomeAmount}
          {withDiff && (
            <div className={b('diff')}>
              {incomeAmountIcon}
              <div className={b('diff-percent', { color: incomeAmountColor })}>{item.incomeAmount.percent}%</div>
              <div className={b('diff-value')}>{formatNumber(item.incomeAmount.previous)}</div>
            </div>
          )}
        </div>
        <div className={b('value')}>{formatNumber(item.incomeAmount.current)}</div>
      </div>
    </div>
  );
};

TableRow.propTypes = {
  item: PropTypes.object.isRequired,
  withDiff: PropTypes.bool.isRequired,
};

export default TableRow;
